import XAPPService from "app/Core/services/XAPPService";

export const GET_MIGRARCADASTRO = "[MIGRARCADASTRO APP] GET MIGRARCADASTRO";
export const SAVE_MIGRARCADASTRO = "[MIGRARCADASTRO APP] SAVE MIGRARCADASTRO";

export const MIGRARCADASTRO_WARNING = "[MIGRARCADASTRO APP] MIGRARCADASTRO WARNING";
export const MIGRARCADASTRO_INFO = "[MIGRARCADASTRO APP] MIGRARCADASTRO INFO";
export const MIGRARCADASTRO_ERROR = "[MIGRARCADASTRO APP] MIGRARCADASTRO ERROR";

export function save(_AState, _AParams) {
    return (dispatch) => {
        var AActions = [];
        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "", "MIGRARCADASTRO", _AState, "", [], [], 1);
        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionpessoaformulario", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: MIGRARCADASTRO_WARNING,
                            payload: response.warning
                        })
                    ]);
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: MIGRARCADASTRO_INFO,
                            payload: response.info
                        })
                    ]);
                }
            }).catch(error => {
                return dispatch({
                    type: MIGRARCADASTRO_ERROR,
                    payload: error
                });
            });
    };
}
